export default {
    /**
     * 阳历节日
     */
    festival: [{
        date: "1-1",
        title: "元旦"
    }, {
        date: "1-10",
        title: "警察节"
    }, {
        date: "3-5",
        title: "学雷锋日"
    }, {
        date: "3-8",
        title: "妇女节"
    }, {
        date: "3-12",
        title: "植树节"
    }, {
        date: "3-15",
        title: "消费者日"
    }, {
        date: "4-1",
        title: "愚人节"
    }, {
        date: "5-1",
        title: "劳动节"
    }, {
        date: "5-4",
        title: "青年节"
    }, {
        date: "5-12",
        title: "护士节"
    }, {
        date: "5-14",
        title: "助残日"
    }, {
        date: "5-19",
        title: "中国旅游日"
    }, {
        date: "6-1",
        title: "儿童节"
    }, {
        date: "6-5",
        title: "环保日"
    }, {
        date: "6-26",
        title: "禁毒日"
    }, {
        date: "7-1",
        title: "中共诞辰"
    }, {
        date: "8-1",
        title: "建军节"
    }, {
        date: "9-10",
        title: "教师节"
    }, {
        date: "10-1",
        title: "国庆节建国"
    }, {
        date: "11-11",
        title: "光棍节"
    }, {
        date: "12-1",
        title: "艾滋病日"
    }, {
        date: "12-12",
        title: "西安事变"
    }, {
        date: "12-24",
        title: "平安夜"
    }, {
        date: "12-25",
        title: "圣诞节"
    }, {
        date:
        //国际假期
            "1-5",
        title: "黑人日"
    }, {
        date: "1-26",
        title: "国际麻风节"
    }, {
        date: "2-2",
        title: "世界湿地日"
    }, {
        date: "2-7",
        title: "国际声援南非日"
    }, {
        date: "2-10",
        title: "国际气象节"
    }, {
        date: "2-14",
        title: "情人节"
    }, {
        date: "2-24",
        title: "第三世界青年日"
    }, {
        date: "2-28",
        title: "世界居住条件调查日"
    }, {
        date: "3-1",
        title: "国际海豹日"
    }, {
        date: "3-3",
        title: "全国爱耳日"
    }, {
        date: "3-14",
        title: "白色情人节"
    }, {
        date: "3-17",
        title: "国际航海日"
    }, {
        date: "3-20",
        title: "世界无肉日"
    }, {
        date: "3-21",
        title: "世界睡眠日"
    }, {
        date: "3-22",
        title: "世界水日"
    }, {
        date: "3-23",
        title: "世界气象日"
    }, {
        date: "4-2",
        title: "国际儿童图书日"
    }, {
        date: "4-3",
        title: "寒食节"
    }, {
        date: "4-7",
        title: "世界卫生日"
    }, {
        date: "4-11",
        title: "世界帕金森病日"
    }, {
        date: "4-21",
        title: "复活节"
    }, {
        date: "4-22",
        title: "世界地球日"
    }, {
        date: "4-23",
        title: "世界读书日"
    }, {
        date: "4-24",
        title: "中国航天日"
    }, {
        date: "4-26",
        title: "世界知识产权日"
    }, {
        date: "4-29",
        title: "世界舞蹈日"
    }, {
        date: "4-30",
        title: "全国交通安全反思日"
    }, {
        date: "5-3",
        title: "世界新闻自由日"
    }, {
        date: "5-8",
        title: "世界红十字日"
    }, {
        date: "5-12",
        title: "国际护士节"
    }, {
        date: "5-15",
        title: "国际家庭日"
    }, {
        date: "5-17",
        title: "世界电信日"
    }, {
        date: "5-18",
        title: "国际博物馆日"
    }, {
        date: "5-20",
        title: "全国助残日"
    }, {
        date: "5-30",
        title: "五卅运动"
    }, {
        date: "5-31",
        title: "世界无烟日"
    }, {
        date: "6-5",
        title: "世界环境日"
    }, {
        date: "6-6",
        title: "全国爱眼日"
    }, {
        date: "6-11",
        title: "中国人口日"
    }, {
        date: "6-20",
        title: "世界难民日"
    }, {
        date: "6-22",
        title: "中国儿童慈善活动日"
    }, {
        date: "6-23",
        title: "国际奥林匹克日"
    }, {
        date: "6-25",
        title: "全国土地日"
    }, {
        date: "6-26",
        title: "国际禁毒日"
    }, {
        date: "6-30",
        title: "世界青年联欢节"
    }, {
        date: "7-2",
        title: "国际体育记者纪念日"
    }, {
        date: "7-6",
        title: "国际接吻日"
    }, {
        date: "7-7",
        title: "七七事变"
    }, {
        date: "7-11",
        title: "世界人口日"
    }, {
        date: "7-16",
        title: "国际冰壶日"
    }, {
        date: "7-28",
        title: "世界肝炎日"
    }, {
        date: "7-29",
        title: "世界爱虎日"
    }, {
        date: "7-30",
        title: "非洲妇女纪念日"
    }, {
        date: "8-6",
        title: "国际电影节"
    }, {
        date: "8-3",
        title: "中国男人节"
    }, {
        date: "8-8",
        title: "中国父亲节"
    }, {
        date: "8-13",
        title: "火把节"
    }, {
        date: "8-15",
        title: "日本投降纪念日"
    }, {
        date: "8-19",
        title: "中国医师节"
    }, {
        date: "8-26",
        title: "全国律师咨询日"
    }, {
        date: "9-3",
        title: "抗战胜利纪念日"
    }, {
        date: "9-8",
        title: "国际扫盲日"
    }, {
        date: "9-10",
        title: "教师节"
    }, {
        date: "9-16",
        title: "国际臭氧层保护日"
    }, {
        date: "9-18",
        title: "九一八纪念日"
    }, {
        date: "9-20",
        title: "国际爱牙日"
    }, {
        date: "9-21",
        title: "国际和平日"
    }, {
        date: "9-22",
        title: "世界无车日"
    }, {
        date: "9-23",
        title: "国际聋人节"
    }, {
        date: "9-27",
        title: "世界旅游日"
    }, {
        date: "9-28",
        title: "孔子诞辰纪念日"
    }, {
        date: "9-30",
        title: "中国烈士纪念日"
    }, {
        date: "10-4",
        title: "世界动物日"
    }, {
        date: "10-9",
        title: "世界邮政日"
    }, {
        date: "10-10",
        title: "辛亥革命纪念日"
    }, {
        date: "10-13",
        title: "中国少年先锋队诞辰"
    }, {
        date: "10-14",
        title: "世界标准日"
    }, {
        date: "10-15",
        title: "国际盲人节"
    }, {
        date: "10-16",
        title: "世界粮食日"
    }, {
        date: "10-17",
        title: "国际消除贫困日"
    }, {
        date: "10-22",
        title: "世界传统医药纪念日"
    }, {
        date: "10-24",
        title: "联合国日"
    }, {
        date: "10-31",
        title: "世界勤俭日"
    }, {
        date: "11-1",
        title: "万圣节"
    }, {
        date: "11-8",
        title: "中国记者日"
    }, {
        date: "11-10",
        title: "世界青年节"
    }, {
        date: "11-14",
        title: "世界糖尿病日"
    }, {
        date: "11-15",
        title: "寒衣节"
    }, {
        date: "11-17",
        title: "国际大学生节"
    }, {
        date: "11-20",
        title: "国际儿童日"
    }, {
        date: "11-21",
        title: "世界问候日"
    }, {
        date: "12-1",
        title: "世界艾滋病日"
    }, {
        date: "12-3",
        title: "国际残疾人日"
    }, {
        date: "12-9",
        title: "'一二九'运动纪念日"
    }, {
        date: "12-9",
        title: "世界足球日"
    }, {
        date: "12-10",
        title: "世界人权日"
    }, {
        date: "12-13",
        title: "南京大屠杀死难者国家公祭日"
    }, {
        date: "12-20",
        title: "澳门回归纪念日"
    }],

    /**
     * 农历节日
     */
    lfestival: [{
            date: "正月初一",
            title: "春节"
        },
        {
            date: "正月十五",
            title: "元宵节"
        },
        {
            date: "二月初二",
            title: "龙抬头"
        },
        {
            date: "三月初三",
            title: "上巳节"
        },
        {
            date: "四月初八",
            title: "佛诞"
        },
        {
            date: "五月初五",
            title: "端午节"
        },
        {
            date: "七月初七",
            title: "七夕"
        },
        {
            date: "七月十五",
            title: "中元节"
        },
        {
            date: "八月十五",
            title: "中秋节"
        },
        {
            date: "九月初九",
            title: "重阳节"
        },
        {
            date: "腊月初八",
            title: "腊八节"
        },
        {
            date: "腊月十六",
            title: "尾牙"
        },
        {
            date: "腊月廿三",
            title: "北方小年"
        },
        {
            date: "腊月廿四",
            title: "南方小年"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/calendar.js